const baseUrl: string = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';

export const getAudioBlob = async (content: string): Promise<Blob> => {
  const accessToken = localStorage.getItem('accessToken');
  
  const response = await fetch(`${baseUrl}/text_to_speech/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`,
    },
    body: JSON.stringify({ text_to_convert: content }),
  });

  if (!response.ok) {
    throw new Error(`Failed to generate audio: ${response.status} ${response.statusText}`);
  }

  return response.blob();
};
